import axios from "axios";

import constant from "@/common/constant";
import AccessUtil from "@/common/AccessUtil";
import { Toast } from 'vant';

const CancelToken = axios.CancelToken;
let source = CancelToken.source();

let service = axios.create({
    baseURL: 'https://luna.vizen.cn'
    // timeout: 15000
});

let loadingContainer = null;
let needLoadingRequestCount = 0;

function startLoading() {
    let barElement1 = document.createElement("div");
    barElement1.setAttribute('class', 'bar');

    let barElement2 = document.createElement("div");
    barElement2.setAttribute('class', 'bar');

    let barElement3 = document.createElement("div");
    barElement3.setAttribute('class', 'bar');

    let loadingElement = document.createElement("div");
    loadingElement.setAttribute('class', 'loading');
    loadingElement.appendChild(barElement1);
    loadingElement.appendChild(barElement2);
    loadingElement.appendChild(barElement3);

    loadingContainer = document.createElement("div");
    loadingContainer.setAttribute('class', 'loading-container');
    loadingContainer.appendChild(loadingElement);

    document.body.appendChild(loadingContainer);
}

function closeLoading() {
    document.body.removeChild(loadingContainer);

    loadingContainer = null;
}

function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading();
    }

    needLoadingRequestCount++;
}

function hideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) {
        return;
    }

    needLoadingRequestCount--;
    if (needLoadingRequestCount === 0) {
        closeLoading();
    }
}

service.interceptors.request.use(
    function(config) {
        showFullScreenLoading();

        // if (AccessUtil.getAuthToken() != null) {
        //     config.headers["X-Auth-Token"] = 'adc7c979dabb48f7943ee0810dfaf59f';
        // }
        
        // config.headers["X-App-Key"] = process.env.VUE_APP_APP_KEY;

        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    function(response) {
        hideFullScreenLoading();

        if (response.data == null) {
            return Promise.reject("Null response");
        }

        if (response.data.code == 0) {
            return response.data;
        } else if (response.data.code === constant.RESPONSE_CODE_LIST.TOKEN_INVALID) {
        

            Toast(response.data.message);


            let baseUrl = process.env.VUE_APP_BASE_URL;
            let reg = new RegExp("\/$"); // eslint-disable-line
            if (reg.test(process.env.VUE_APP_BASE_URL)) {
                baseUrl = process.env.VUE_APP_BASE_URL.substring(0, process.env.VUE_APP_BASE_URL.length-1)
            }

            location.href = baseUrl + "/login";
        } else if (response.data.code !== constant.RESPONSE_CODE_LIST.SUCCESS
            && response.data.code !== constant.RESPONSE_CODE_LIST.TOKEN_INVALID) {
            
           

                Toast(response.data.message);


            return response.data;
        } else {
            return Promise.reject("未知错误");
        }
    },
    function(error) {
        hideFullScreenLoading();
        
        Toast(response.data.message);


        return Promise.reject(error);
    }
);

export default {

    getQueryString(name){
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if(r!=null)return  unescape(r[2]); return null;
    },
    
    get(url, param) {
        return new Promise((resolve, reject) => {
            service({
                method: "get",
                url,
                params: param,
                cancelToken: source.token
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    post(url, param, data) {
        return new Promise((resolve, reject) => {
            data = Qs.stringify(data);
            service({
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                method: "post",
                url,
                params: param,
                data: data,
                cancelToken: source.token
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    put(url, param, data) {
        return new Promise((resolve, reject) => {
            service({
                method: "put",
                url,
                params: param,
                data: data,
                cancelToken: source.token
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    delete(url, param, data) {
        return new Promise((resolve, reject) => {
            service({
                method: "delete",
                url,
                params: param,
                data: data,
                cancelToken: source.token
            }).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    }
};
